export const EVENTS = {
  SEARCH_FILTERS: {
    SHOW_DIALOG: 'search_filters.SHOW_DIALOG',
    HIDE_DIALOG: 'search_filters.HIDE_DIALOG',
    SORT_UPDATED: 'search_filters.sort_updated',
    PRICE_UPDATED: 'search_filters.price_updated',
    CATEGORY_TOGGLED: 'search_filters.category_toggled',
    FILTERS_UPDATED: 'search_filters.filters_updated',
    RESET_FILTERS: 'search_filters.reset_filters',
    SET_ALL_FILTERS: 'search_filters.set_all_filters'
  }
};

export const SORT_OPTIONS = {
  NEAR: 'near',
  COOK_DURATION: 'cookDuration',
  PRICE: 'price',
  POPULARITY: 'popularity'
};

export const SORT_LABELS = {
  [SORT_OPTIONS.NEAR]: 'Restau à coté',
  [SORT_OPTIONS.COOK_DURATION]: 'Temps de préparation',
  [SORT_OPTIONS.PRICE]: 'Remas moins Cher',
  [SORT_OPTIONS.POPULARITY]: 'Popularité'
};

export const PRICE_RANGES = [
  { id: '1000f', label: '1000f', min: 0, max: 2000 },
  { id: '2500f', label: '2500f', min: 2000, max: 4500 },
  { id: '5000f', label: '5000f', min: 4500, max: 9000 },
  { id: '10000f', label: '10000f', min: 9000, max: 18000 },
  { id: '20000f', label: '20000f', min: 18000, max: 28000 },
  { id: '30000f', label: '30000f', min: 28000, max: 60000 }
];

export const DEFAULT_STATE = {
  selectedSort: null,
  selectedPriceRange: null,
  selectedCategories: [],
  filters: {}
};
